function deleteSession() {
    document.cookie = "session_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "userId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "nome_completo=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "boardIs=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "permissao=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

export default deleteSession;
